import { NgModule, provideAppInitializer } from '@angular/core';

import { bestsellerConfigsInjectionTokenProvider } from './configs/tenants/bestseller/injection-token';
import { brooksConfigsInjectionTokenProvider } from './configs/tenants/brooks/injection-token';
import { commonConfigsInjectionTokenProvider } from './configs/tenants/common/injection-token';
import { espritConfigsInjectionTokenProvider } from './configs/tenants/esprit/injection-token';
import { pumaConfigsInjectionTokenProvider } from './configs/tenants/puma/injection-token';
import { initializeLibrary } from './initialize-lib';

@NgModule({
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initializeLibrary();
      return initializerFn();
    }),
    bestsellerConfigsInjectionTokenProvider,
    brooksConfigsInjectionTokenProvider,
    commonConfigsInjectionTokenProvider,
    espritConfigsInjectionTokenProvider,
    pumaConfigsInjectionTokenProvider,
  ],
})
export class DynamicComponentsConfigsModule {}
